const divModalFilterService = {
  cancel: 'CANCELAR',
  ok: 'APLICAR'
};

export default divModalFilterService;
